import React from 'react'

import { Dropdown } from 'bootstrap.native'

import '../styles/activeCallList-filter'

class SiteDropDown extends React.Component {

    initializeDropdown(element, persist) {
        if (element && !element.Dropdown) {
            new Dropdown(element, persist)
        }
    }

    render() {
        const { className, filter, onChange, sites } = this.props
        const site = filter
        const siteDropdownText = filter ? sites.filter(s => s.key === filter).map(s => s.name) || filter : 'All'

        return (
            <div className="site dropdown">
                <button type="button" className="btn btn-default dropdown-toggle" ref={e => this.initializeDropdown(e)}>
                    Site <span className="small">[{siteDropdownText}]</span>&nbsp;&nbsp;<span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                    <li><a href="#" onClick={() => onChange("")}>All</a></li>
                    <li role="separator" className="divider"></li>
                    {sites.sort((x, y) => x.name.localeCompare(y.name)).map(site => {
                        const key = site.key || site
                        const name = site.name || site
                        return <li key={key}>
                            <a href="#" onClick={() => onChange(key)} tabIndex="-1">{name}</a>
                        </li>
                    })}
                </ul>
            </div>
        )
    }
}

export default SiteDropDown



// WEBPACK FOOTER //
// ./components/SiteDropDown.jsx